import { useChatInputStore, useModelStore } from '@/store';

// Resolve Arya by its stable catalog slug, never a hard-coded database ID.
// A user edit or model choice cancels a pending lookup.
export function selectUseCaseModel(slug) {
  if (slug !== 'arya') return;
  const composer = useChatInputStore.getState();
  const models = useModelStore.getState();
  const select = model => {
    if (model?.id && model.slug === slug) useChatInputStore.getState().setSelectedModels([model.id]);
  };
  const cached = models.getModelBySlug(slug);
  if (cached) { select(cached); return; }
  let cancelled = false;
  const stop = useChatInputStore.subscribe((state, previous) => {
    if (state.currentContextId !== 'new' || state.inputStates.new !== previous.inputStates.new) cancelled = true;
  });
  Promise.resolve(models.fetchModelBySlug(slug)).then(model => {
    if (!cancelled && useChatInputStore.getState().currentContextId === composer.currentContextId) select(model);
  }).catch(() => { /* Keep the editable draft and the regular model selector. */ }).finally(stop);
}
